import React from 'react';

interface ErrorMessageProps {
  message: string;
  details?: string[];
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, details, className }) => {
  if (!message) {
    return null;
  }

  return (
    <div
      role="alert"
      className={`bg-red-50 border-l-4 border-red-500 text-red-800 p-6 mb-8 rounded-lg shadow-sm max-w-4xl ${className || ''}`}
    >
      <div className="flex items-center">
        <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <p className="font-semibold text-lg">{message}</p>
      </div>
      {details && details.length > 0 && (
        <ul className="list-disc list-inside space-y-1 ml-9 mt-3">
          {details.map((detail) => (
            <li key={detail} className="text-sm">
              {detail}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ErrorMessage;
